<template>
    <div>
        <!-- <vxe-button @click="exportEvent">导出</vxe-button> -->
        <vxe-toolbar :buttons="toolbarButtons" @button-click="buttonClickEvent" ref="toolbarRef" custom >
           
        </vxe-toolbar>
        <vxe-table border :data="tableData" ref="tableRef" :column-config="{resizable: true}"  :columns="columns"  stripe width="100%">
            <vxe-column v-for="(column,index) in columns" :field="column.field" :title="column.title" align="center" ></vxe-column>
            <!-- <vxe-column field="age" title="Age" width="auto"></vxe-column> -->
            <!-- <vxe-column field="address" title="Address" width="200"></vxe-column>  -->
        </vxe-table>
    </div>
</template>
<script>
    export default {
        name:'userPcInfo',
        created() {
            this.$api.managementGetAll( ).then(res =>{
                this.columns = res.columns;
                this.tableData = res.tableData;
            })
    },
    mounted() {
    },
    data() {
        const toolbarButtons = [
            { name: '导出', code: 'export', status: 'primary' },
            // { name: '删除', code: 'del', status: 'error' },
            // { name: '保存', code: 'save', status: 'success' }
        ]
        return {
            toolbarButtons,
            tableData: [
                // { name: 'John', age: 25, address: 'New York' },
                // { name: 'Jane', age: 28, address: 'Los Angeles' },
                // { name: 'Alice', age: 22, address: 'Chicago' },
                // more data...
            ],
            columns: [
                // { field: 'name', title: 'Name', width: 120 },
                // { field: 'age', title: 'Age', width: 80 },
                // { field: 'address', title: 'Address', width: 200 },
                // dynamic columns
            ],

        }
    },
    methods: {
        buttonClickEvent({ code }) {
            if (code === 'export') {
                this.exportEvent();
            }
        },
        exportEvent() {
            const $table = this.$refs.tableRef;
            if ($table) {
                $table.exportData({
                    type: 'xlsx',
                    filename:'电脑数据'
                });
            }
        },
    }
    }
</script>

<style lang="less" scoped>
/deep/ .vxe-table--render-default.is--padding .vxe-body--column{
    padding: 1px !important;
}
.vxe-toolbar{
    padding: 0 !important;
}
</style>